module.exports = __webpack_public_path__ + "static/media/stanfordLogo.3b758ef5.png";